<button
  class="export-button"
  [ngClass]="{ 'export-button-loading': waitingForFile() }"
  (click)="exportToCSV()"
  [disabled]="disabled()"
  [matTooltip]="tooltipKey() | labelsProvider"
  matTooltipPosition="below"
  matTooltipClass="tooltip-container"
>
  @if (!waitingForFile()) {
    <img src="assets/images/common/export.svg" alt="export" />
  }

  @if (!waitingForFile() && !displayCheckMark()) {
    <div>
      {{ 'common.export' | labelsProvider }}
    </div>
  }

  @if (waitingForFile()) {
    <mat-progress-spinner class="export-button-spinner" color="primary" mode="indeterminate"> </mat-progress-spinner>
  }

  @if (displayCheckMark()) {
    <div>
      <img src="assets/images/common/checked.svg" />
    </div>
  }
</button>
